'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _listingModule = require('./listingModule');

var _listingsModule = require('../listings/listingsModule');

var _utils = require('../utils');

var _AnalyticsModule = require('../analytics/modules/AnalyticsModule');

var AnalyticsModule = _interopRequireWildcard(_AnalyticsModule);

var _analytics = require('../constants/analytics');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnrollModal = function EnrollModal(_ref) {
  var isEnrollModalOpen = _ref.isEnrollModalOpen,
      toggle = _ref.toggle,
      modalNames = _ref.modalNames,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      checkForConnection = _ref.checkForConnection,
      updateConnectionOnIndex = _ref.updateConnectionOnIndex,
      trackButtonClick = _ref.trackButtonClick,
      userId = _ref.userId,
      companyUUID = _ref.companyUUID,
      listingData = _ref.listingData;


  /*
  * This function is a hack. Code in CTE looks for the existance of
  * this function. If it exists, the styles will work without us needing
  * to hack them in. If removed, all hell breaks loose. For the love
  * of God, do not remove.
  */

  window.otHidePopupDialog = function () {};

  var listingName = void 0;
  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  var toggleThisModal = function toggleThisModal() {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.enroll, _analytics.button.x],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggle(modalNames.enroll);
  };

  if (!(0, _utils.canUseDOM)()) {
    return _react2.default.createElement(
      'span',
      null,
      'JavaScript is Required to Enroll'
    );
  }
  var style = {
    overlay: {
      zIndex: '100',
      position: 'fixed',
      overflow: 'scroll',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
      position: 'initial',
      width: '90%', // ipm uses 835 x 565
      margin: '25px auto',
      overflow: 'scroll'
    }
  };

  var accessIframeEl = function accessIframeEl(selector) {
    var getIframeEl = function getIframeEl() {
      return document.getElementById('autoconnectframe').contentWindow.document;
    };

    var el = getIframeEl().querySelector(selector);

    var listener = function listener(element, cb) {
      element.addEventListener('click', function (event) {
        cb(element, event);
      });
      return { addEventListener: listener.bind(undefined, element) };
    };

    var adjustElement = function adjustElement(element, cb) {
      cb(element);
    };

    return {
      addEventListener: listener.bind(undefined, el),
      element: adjustElement.bind(undefined, el)
    };
  };

  var keyPressed = function keyPressed(event) {
    if (event.keyCode === 13) {
      toggleThisModal();
    }
  };

  var toggleConnectedStatus = function toggleConnectedStatus() {
    checkForConnection(listingId, v1ListingId);
    updateConnectionOnIndex(listingId, true);
  };

  var counter = 0;
  var addDismissEventListener = function addDismissEventListener() {
    window.setTimeout(function () {
      if (counter < 5) {
        try {
          accessIframeEl('button.ui-button').addEventListener(toggleConnectedStatus).addEventListener(toggleThisModal).addEventListener('keydown', keyPressed);
        } catch (e) {
          addDismissEventListener(counter++);
        }
      }
    }, 500);
  };

  if (isEnrollModalOpen) {
    window.requestAnimationFrame(function () {
      if (document.getElementById('autoconnectframe')) {
        document.getElementById('autoconnectframe').onload = function () {
          accessIframeEl('#enrollbutton').addEventListener(addDismissEventListener);
          accessIframeEl('a.cnqr-connect-appcenter-autoconnect-button-cancel').addEventListener(function () {
            toggleThisModal();
          });
        };
      }
    });
  }

  _reactModal2.default.setAppElement('#root');
  return _react2.default.createElement(
    'div',
    { className: 'modal-container' },
    _react2.default.createElement(
      _reactModal2.default,
      {
        style: style,
        isOpen: isEnrollModalOpen,
        onRequestClose: toggleThisModal,
        contentLabel: 'Enroll in listing modal'
      },
      _react2.default.createElement(
        'div',
        { className: 'row inside-modal' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-10 col-xs-offset-1' },
          _react2.default.createElement('iframe', {
            name: 'autoconnect',
            style: { border: 'none', overflow: 'scroll' },
            width: '100%', height: '580px',
            id: 'autoconnectframe',
            src: _config2.default.enrollModalBase + '/UI/appcenter/AutoConnect?source=ipm'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-1' },
          _react2.default.createElement(
            'span',
            {
              className: 'close-tandc-modal pull-right',
              onClick: toggleThisModal
            },
            '\xD7'
          )
        )
      )
    )
  );
};

EnrollModal.propTypes = {
  isEnrollModalOpen: _propTypes2.default.bool.isRequired,
  toggle: _propTypes2.default.func.isRequired,
  modalNames: _propTypes2.default.object.isRequired,
  listingId: _propTypes2.default.string.isRequired,
  v1ListingId: _propTypes2.default.string.isRequired,
  updateConnectionOnIndex: _propTypes2.default.func.isRequired,
  checkForConnection: _propTypes2.default.func.isRequired,
  trackButtonClick: _propTypes2.default.func,
  userId: _propTypes2.default.string,
  companyUUID: _propTypes2.default.string,
  listingName: _propTypes2.default.string,
  listingData: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isEnrollModalOpen: state.listing.isEnrollModalOpen,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    companyUUID: state.userPrefs.companyUUID,
    listingData: state.listing
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  toggle: _listingModule.toggleModal,
  checkForConnection: _listingModule.checkForConnection,
  updateConnectionOnIndex: _listingsModule.updateConnectedStatus,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})(EnrollModal);


//////////////////
// WEBPACK FOOTER
// ./lib/listing/EnrollModal.js
// module id = 591
// module chunks = 0